export default __webpack_public_path__ + "static/media/vende-tu-auto-mobile.3072b4ec.png";